import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FiAlertTriangle } from 'react-icons/fi';
import { Grid } from '@inplayer-org/inplayer-ui';

const { Container, Cell } = Grid;

const TopContainer = styled(Container)`
  border: 1px solid #d7dde5;
  padding: 1rem;
  border-radius: 4px;
`;

const InnerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`;

const Alert: FunctionComponent = ({ children }) => (
  <TopContainer columns="auto 1fr" gap="0.75rem">
    <Cell>
      <FiAlertTriangle size="20" />
    </Cell>
    <Cell>
      <InnerTextContainer>{children}</InnerTextContainer>
    </Cell>
  </TopContainer>
);

export default Alert;
